import { ReactNode } from 'react';
import { FieldValues, FormProvider as Form, UseFormReturn } from 'react-hook-form';

//
//

type Props<T extends FieldValues = FieldValues> = {
  children: ReactNode;
  methods: UseFormReturn<T>;
  onSubmit?: VoidFunction;
  id?: string;
};

export default function FormProvider<T extends FieldValues = FieldValues>({ children, onSubmit, methods, id }: Props<T>) {
  return (
    <Form {...methods}>
      <form id={id} onSubmit={onSubmit}>{children}</form>
    </Form>
  );
}
